import { Injectable } from '@angular/core';
import { ChecklistOfflineService } from './checklist-offline.service';
import { Capacitor } from '@capacitor/core';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';

@Injectable({
  providedIn: 'root'
})
//ImageProcessorService
export class ExtractHtmlImgService {

  constructor(
    private file: File,
    private nativeHTTP: HTTP,
  ) { }

  /**
   * Procesa HTML descargando imágenes y reemplazando URLs - Versión autónoma
   * @param htmlString - String HTML que contiene imágenes
   * @returns Promise con el HTML modificado con rutas locales
  */

  async processHtmlImages(htmlString: string): Promise<string> {
    try {
      // Crear un parser DOM
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');

      // Obtener todas las imágenes
      const imgElements = doc.querySelectorAll('img');

      if (imgElements.length === 0) {
        return htmlString;
      }

      console.log(`Procesando ${imgElements.length} imagenes...`);

      const imageArray = Array.from(imgElements); // convierte NodeList a array real

      for (let imgElement of imageArray) {
        const originalSrc = imgElement.getAttribute('src');
        console.log("originalSrc:: ", originalSrc)
        if (originalSrc && originalSrc.trim() !== '') {
          try {
            let fileName = `img_${Date.now()}`;
            console.log(`Imagen de html Y fileName:: ${originalSrc}`, fileName);
            const localPath = await this.downloadHtmlImage(
              { url: originalSrc, media_id: fileName }, "photo"
            );
            const webViewPath = Capacitor.convertFileSrc(localPath);
            imgElement.setAttribute('src', webViewPath);
            console.log(`Imagen de html procesada: ${originalSrc} -> ${webViewPath}`);
          } catch (error) {
            console.error(`Error descargando imagen de html de act ${originalSrc}:`, error);
            imgElement.setAttribute('src', "");
            // Mantener src original si falla la descarga
          }
        }
      }

      // // Procesar cada imagen
      // const downloadPromises = Array.from(imgElements).map(async (imgElement, index) => {
      //   const originalSrc = imgElement.getAttribute('src');
      //   if (originalSrc && originalSrc.trim() !== '') {
      //     try {
      //       let fileName = `img_${index}_${Date.now()}`;
      //       console.log(`Imagen de html:: ${originalSrc}`, fileName);
      //       const localPath = await this.downloadHtmlImage(
      //         { url: originalSrc, media_id: fileName }, "photo"
      //       );
      //       const webViewPath = Capacitor.convertFileSrc(localPath);
      //       imgElement.setAttribute('src', webViewPath);
      //       console.log(`Imagen de html procesada: ${originalSrc} -> ${webViewPath}`);
      //     } catch (error) {
      //       console.error(`Error descargando imagen de html de act ${originalSrc}:`, error);
      //       // Mantener src original si falla la descarga
      //     }
      //   }
      // });

      // // Esperar todas las descargas
      // await Promise.all(downloadPromises);

      // Retornar el HTML modificado
      return doc.body.innerHTML;

    } catch (error) {
      console.error('Error procesando HTML con imágenes:', error);
      return htmlString; // Retornar HTML original en caso de error
    }
  }

  async downloadHtmlImage(media, type): Promise<string> {
    //  for (const photo of photos) {
       let url_media: string = media.url;
       let localUrl = "";

       try {
         // Intentar obtener extensión de la URL
         let extension = this.getFileExtensionFromUrl(url_media);

         // Si no se puede obtener la extensión de la URL, detectar por content-type
         if (!extension) {
           console.log('No extension found in URL, detecting content type...');
          //  if(type === "photo") {
             extension = await this.detectContentType(url_media);
            // }
         }

         let docName = `${media.media_id}.${extension}`;
         let filePath;
        // if(type === "photo") {
          filePath = this.file.dataDirectory + '/ch-img-description/' + docName;
          // Verificar/crear carpeta
          let coverFolder = await this.checkOnlineImgFolder();
          console.log('Directory ch-img-description exists:', coverFolder);


          if (!coverFolder) {
            let coverFolderCreated = await this.createOnlineImgFolder();
            console.log('Directory ch-img-description created:', coverFolderCreated);
            if (!coverFolderCreated) {
              throw new Error('Could not create ch-img-description directory');
            }
          };

        // }

        // Descargar archivo
         const responseDownload = await this.nativeHTTP.downloadFile(url_media, {}, {}, filePath);
         localUrl = responseDownload.nativeURL;
         console.log('ch-img-description Descargado en:', responseDownload.nativeURL);

         return localUrl;

       } catch (err) {
         console.log('error block ... ', err.status, JSON.stringify(err.error));
         return localUrl;
       }
    //  }
  }

  private getFileExtensionFromUrl(url: string): string {
    try {
      // Remover parámetros de query (?param=value)
      const urlWithoutParams = url.split('?')[0];

      // Extraer la extensión
      const parts = urlWithoutParams.split('.');
      if (parts.length > 1) {
        const extension = parts[parts.length - 1].toLowerCase();
        // Validar que sea una extensión de imagen común
        const validExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'mp4', 'webm', 'mpeg', 'mov'];
        if (validExtensions.includes(extension)) {
          return extension;
        }
      }
      return null;
    } catch (error) {
      console.log('Error extracting extension:', error);
      return null;
    }
  }

    private async detectContentType(url: string): Promise<string> {
    try {
      // Realizar petición HEAD para obtener headers sin descargar el contenido
      const response = await this.nativeHTTP.sendRequest(url, {
        method: 'head',
        serializer: 'json'
      });

      const contentType = response.headers['content-type'] || response.headers['Content-Type'];

      if (contentType) {
        // Mapear content-type a extensión
        const typeMap = {
          'image/jpeg': 'jpg',
          'image/jpg': 'jpg',
          'image/png': 'png',
          'image/gif': 'gif',
          'image/webp': 'webp',
          'image/bmp': 'bmp',
          'image/svg+xml': 'svg'
        };

        return typeMap[contentType.toLowerCase()] || 'jpg'; // Default a jpg
      }

      return 'jpg'; // Default fallback
    } catch (error) {
      console.log('Error detecting content type:', error);
      return 'jpg'; // Default fallback
    }
  }

  async checkOnlineImgFolder():Promise<boolean> {
		try {
			await this.file.checkDir(this.file.dataDirectory, 'ch-img-description');
			return true;
		} catch (error) {
			return false;
		}
	}

  async createOnlineImgFolder():Promise<boolean> {
		try {
			await this.file.createDir(this.file.dataDirectory, 'ch-img-description', false);
			return true;
		} catch (error) {
			return false;
		}
	}


}

